import { DateRange } from "controls";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";

const SpecifyDate = ({ values, setValues, errors }) => {
  const [sortDate, setSortDate] = useState({
    fromDate: dayjs().subtract(3, "month").startOf("month"),
    toDate: dayjs().toDate(),
  });

  useEffect(() => {
    setValues((prev) => ({
      ...prev,
      fromDate: new Date(sortDate.fromDate),
      toDate: new Date(sortDate.toDate),
    }));

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortDate]);

  return (
    <div>
      <DateRange
        className="w-full"
        error={errors.numberOfPeriod}
        {...{ sortDate, setSortDate }}
      />
    </div>
  );
};

export default SpecifyDate;
